import firebase from 'firebase'
import store from '../store/store'

let config = {
  // deploy
  apiKey: 'AIzaSyAnIsXqF3IS-biSrFuW1UsZwCpfMcjJjkQ',
  authDomain: 'fir-project-797ad.firebaseapp.com',
  databaseURL: 'https://fir-project-797ad.firebaseio.com',
  projectId: 'fir-project-797ad',
  storageBucket: 'fir-project-797ad.appspot.com',
  messagingSenderId: '353809081261'
  // dev
  /* apiKey: "AIzaSyDKJTbFPQ9uXJSaGoQ4HNDrGfLomkYwtiY",
  authDomain: "upload-test-a9c87.firebaseapp.com",
  databaseURL: "https://upload-test-a9c87.firebaseio.com",
  projectId: "upload-test-a9c87",
  storageBucket: "upload-test-a9c87.appspot.com",
  messagingSenderId: "535602409987" */
}

const firebaseApp = firebase.initializeApp(config)
const db = firebaseApp.database()

const initializeAuth = new Promise(resolve => {
  firebase.auth().onAuthStateChanged(user => {
    authService.setUser(user)
    resolve(user)
  })
})

const authService = {

  user: null,

  authenticated () {
    return initializeAuth.then(user => {
      return user
    })
  },

  setUser (user) { // set additional user data passing user to store
    if (user) {
      store.dispatch('setUser', user)
    } else {
      store.dispatch('setUser', null)
    }
    this.user = user
  },

  userCreate (email, password) {
    return firebase.auth().createUserWithEmailAndPassword(email, password).then(function () {
      var user = firebase.auth().currentUser
      if (user) {
        db.ref('users/' + user.uid).set({
          email: user.email,
          isAdmin: false
        })
      } else {
        console.log('There is no current user')
      }
    }).catch(function (error) {
      window.alert(error.message)
    }).then(() => { return firebase.auth().signOut().then(() => { window.location.href = '/' }) })
  },

  userDelete (uid) {
    db.ref('users/' + uid).remove()
    window.location.href = '/#/users'
  },

  login (email, password) {
    return firebase.auth().signInWithEmailAndPassword(email, password).then(function () {
    }).catch(function (error) {
      window.alert(error.message + ' Contact platform@marcastudio.com for more details.')
    })
  },

  logout () {
    return firebase.auth().signOut().then(() => { window.location.href = '/' })
  },

  reset (email) {
    return firebase.auth().sendPasswordResetEmail(email).then(function () {
      window.alert('Password Reset Email Sent!')
      window.location.href = '/'
    }).catch(function (error) {
      window.alert(error.message + ' Contact platform@marcastudio.com for more details.')
    })
  },

  setNewPassword () {
    /* global URLSearchParams */
    var urlParams = new URLSearchParams(window.location.search)
    console.log(urlParams.get('mode'))
    console.log(urlParams.get('oobCode'))
    console.log(urlParams.get('apiKey'))
  }
}

export { db, authService }



// WEBPACK FOOTER //
// ./src/helpers/helpers.js